var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_353",
    "data-name": "Group 353",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.675,
    height: 25.693,
    viewBox: "0 0 25.675 25.693",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M703.913,228.582l4.076,3.937-5.558,1.621Z",
    transform: "translate(-693.673 -217.259)",
    fill: "#37b3a2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M725.712,134.336l4.029,3.89,8.753-8.661-4.029-3.937Z",
    transform: "translate(-714.87 -123.522)",
    fill: "#37b3a2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M830.736,103.462l4.029,3.983,1.011-1.011a1.334,1.334,0,0,0,0-1.887l-2.037-2.037a1.413,1.413,0,0,0-1.971-.026Z",
    transform: "translate(-810.492 -102.097)",
    fill: "#37b3a2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M629.538,118.466v13.413a3.875,3.875,0,0,1-3.875,3.875H608.474a3.875,3.875,0,0,1-3.875-3.875v-17.16a3.875,3.875,0,0,1,3.875-3.875h13.677l-2.585,2.462h-9.921a2.472,2.472,0,0,0-2.472,2.472V130.86a2.472,2.472,0,0,0,2.472,2.472h15a2.472,2.472,0,0,0,2.472-2.472V120.734Z",
    transform: "translate(-604.599 -110.061)",
    fill: "#37b3a2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.c257d799.svg";
export { ForwardRef as ReactComponent };